module.exports = "<app-menu-bar theme=\"white\" notFoundPage=\"true\"></app-menu-bar>\n\n<div class=\"page-not-found\">\n  <div class=\"page-not-found-description\">\n    <img src=\"assets/images/ota404.png\" alt=\"\" class=\"img-responsive\">\n    <div class=\"text-not-found-strong\"><strong>Error 404 Page Not found</strong></div>\n    <div class=\"text-not-found\">The request URL was not found on this server. That's all we know.</div>\n  </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/page-not-found-module/page-not-found/page-not-found.component.html
// module id = 1098
// module chunks = 22